
import { useNavigate, useParams } from "react-router-dom";
import PageHeaderProps from "../../../../model/PageHeaderProps";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import Container from "../../../layout/Container";
import Header from "../../../layout/Header";
import PageContainer from "../../../layout/PageContainer";
import { useEffect, useState } from "react";
import Client from "../../../../model/Client";
import ClientContact from "../../../../model/ClientContact";
import EditClientForm from "../../../elements/Client/EditClientForm";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { deleteClient, resetDeleteSuccess, resetUpdateSuccess, updateClient } from "../../../../store/actions/clientActions";
import { deleteSuccessSelector, deletingClientSelector, saveSuccessSelector, updatingClientSelector } from "../../../../store/selectors/clientSelector";
import LoadingOverlay from "../../../elements/LoadingOverlay";
import DeleteDialog from "../../../elements/GenericDeleteDialog";


const ClientDetailPage: React.FC<PageHeaderProps> = ({isNavOpen, setIsNavOpen}) => {
    const dispatch = useAppDispatch();
    const { id } = useParams();    
    const navigate = useNavigate();
    
    const client = useAppSelector(state => state.client.clients.find(x => x.clientId === parseInt(id ?? "", 10)))
    const isUpdating = useAppSelector(updatingClientSelector);
    const isDeleting = useAppSelector(deletingClientSelector);
    const updateSuccessful = useAppSelector(saveSuccessSelector);
    const deleteSuccessful = useAppSelector(deleteSuccessSelector)

    
    const [editClient, setEditClient] = useState<Client | null>(client !== undefined ? { ...client } : null);    
    const [newContacts, setNewContacts] = useState<ClientContact[]>([]);
    const [canSave, setCanSave] = useState<boolean>(false);
    const [showConfirmation, setConfirmation] = useState<boolean>(false);

    

    useEffect(() => {
        if(editClient === null) {
            console.log("goingback")
            navigate(-1)
        }
    }, [navigate, editClient ])

    useEffect(() => {
        if(updateSuccessful || deleteSuccessful) {            
            dispatch(resetUpdateSuccess());
            dispatch(resetDeleteSuccess());
            navigate("/portal/clients");
        }
    }, [updateSuccessful, deleteSuccessful, navigate]);

    const handleSave = () => {
        dispatch(updateClient({
            ...editClient!,
            contacts: [
                ...editClient!.contacts,
                ...newContacts
            ]
        }))
    }

    const handleDelete = () => {
        dispatch(deleteClient({ 
            clientId: editClient!.clientId
        }));
        setConfirmation(false);
    }

    return <PageContainer>
    <Header title={"Clients"} isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen} showBack={true} />
    <Container style={{ padding: "1rem" }}>
        {editClient !== null && client !== undefined && <>
                <Box display="flex" justifyContent="space-between">
                    <h2 style={{ margin: "1rem 0 2rem 0"}}>Edit {client?.code ?? "Not found"}</h2>
                    <div>
                        <Button 
                            color="error"                            
                            sx={{ margin: "1rem"}}
                            onClick={() => setConfirmation(true)}>
                            Delete
                        </Button>    
                        <Button 
                            variant="contained" 
                            disabled={!canSave}
                            sx={{ margin: "1rem"}}
                            onClick={handleSave}>
                            Save
                        </Button>    
                    </div>
                </Box>
        
                <EditClientForm ogClient={client} editClient={editClient} setEditClient={setEditClient} newContacts={newContacts} setNewContacts={setNewContacts} setCanSave={setCanSave}/>        
                <Box display="flex" justifyContent="space-between">                
                    <Button 
                        variant="contained" 
                        disabled={!canSave}
                        sx={{ margin: "1rem"}}
                        onClick={handleSave}>
                        Save
                    </Button>                    
                </Box>
            </>
        }

        {isUpdating &&
            <LoadingOverlay text="Updating Client..." />
        }

        {isDeleting &&
            <LoadingOverlay text="Deleting Client..." />
        }

        <DeleteDialog 
            show={showConfirmation}
            message={"are you sure you want to delete client with code " + editClient?.code + "?"}
            onAccept={() => {
                handleDelete();
            }}
            onHide={() => setConfirmation(false)}
        />
        
    </Container>
</PageContainer>
}

export default ClientDetailPage;